export const facilitiesfields = {
  facilities: {
    AllFacilities: [
      {
        id: 1,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0101",
        name: "救護施設",
      },
      {
        id: 2,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0102",
        name: "更生施設",
      },
      {
        id: 3,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0103",
        name: "授産施設",
      },
      {
        id: 6,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0831",
        name: "認定生活困窮者就労訓練事業",
      },
      {
        id: 7,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5101",
        name: "生計困難者助葬事業",
      },
      {
        id: 8,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5102",
        name: "無低利子資金融通事業",
      },
      {
        id: 9,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5103",
        name: "生活必需品等を与える事業",
      },
      {
        id: 10,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5104",
        name: "診療施設（医療保護施設）",
      },
      {
        id: 11,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5106",
        name: "簡易住宅貸付・宿泊所利用事業",
      },
      {
        id: 12,
        category: "生活保護及び自立支援に関係する施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5190",
        name: "その他生活困難者施設・事業",
      },
      {
        id: 13,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0201",
        name: "乳児院（乳児預かり所を含む）",
      },
      {
        id: 14,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0202",
        name: "母子生活支援施設",
      },
      {
        id: 15,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0203",
        name: "保育所",
      },
      {
        id: 16,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0204",
        name: "児童養護施設",
      },
      {
        id: 17,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0211",
        name: "児童心理治療施設",
      },
      {
        id: 18,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0212",
        name: "児童自立支援施設",
      },
      {
        id: 19,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0214",
        name: "幼保連携型認定こども園",
      },
      {
        id: 20,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0293",
        name: "保育所（認定こども園移行）",
      },
      {
        id: 21,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0807",
        name: "児童自立生活援助事業",
      },
      {
        id: 22,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0827",
        name: "小規模住居型児童養育事業",
      },
      {
        id: 23,
        category: "児童福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0830",
        name: "小規模保育事業",
      },
      {
        id: 24,
        category: "児童福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3201",
        name: "障害児入所施設",
      },
      {
        id: 25,
        category: "児童福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3215",
        name: "障害児通所支援事業",
      },
      {
        id: 26,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5201",
        name: "助産施設",
      },
      {
        id: 27,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5202",
        name: "児童厚生施設",
      },
      {
        id: 28,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5203",
        name: "児童家庭支援センター",
      },
      {
        id: 29,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5204",
        name: "障害児相談支援事業",
      },
      {
        id: 30,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5205",
        name: "放課後児童健全育成事業",
      },
      {
        id: 31,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5206",
        name: "児童福祉増進相談事業",
      },
      {
        id: 32,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5207",
        name: "法定外保育施設",
      },
      {
        id: 33,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5208",
        name: "児童デイサービス事業",
      },
      {
        id: 34,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5209",
        name: "乳児家庭全戸訪問事業",
      },
      {
        id: 35,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5210",
        name: "養育支援訪問事業",
      },
      {
        id: 36,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5211",
        name: "地域子育て支援拠点事業",
      },
      {
        id: 37,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5212",
        name: "一時預かり事業",
      },
      {
        id: 38,
        category: "児童福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5290",
        name: "その他児童施設・事業",
      },
      {
        id: 39,
        category: "老人福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0301",
        name: "養護老人ホーム",
      },
      {
        id: 40,
        category: "老人福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0303",
        name: "軽費老人ホーム（介護保険法の規定に基づく指定に係るものを除く）",
      },
      {
        id: 41,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3101",
        name: "特別養護老人ホーム",
      },
      {
        id: 42,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3102",
        name: "軽費老人ホーム（介護保険法の規定に基づく指定に係るもの）",
      },
      {
        id: 43,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3103",
        name: "老人居宅介護等事業（ホームヘルプ）",
      },
      {
        id: 44,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3104",
        name: "小規模多機能型居宅介護事業",
      },
      {
        id: 45,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3105",
        name: "認知症対応型老人共同生活援助事業（グループホーム）",
      },
      {
        id: 46,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3106",
        name: "老人デイサービスセンター",
      },
      {
        id: 47,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3107",
        name: "老人短期入所施設",
      },
      {
        id: 48,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3108",
        name: "複合型サービス福祉事業",
      },
      {
        id: 49,
        category: "老人福祉に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3109",
        name: "老人福祉センター内の老人デイサービス事業",
      },
      {
        id: 50,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5301",
        name: "老人福祉センター",
      },
      {
        id: 51,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5302",
        name: "老人介護支援センター",
      },
      {
        id: 52,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5303",
        name: "介護老人保健施設",
      },
      {
        id: 53,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5304",
        name: "指定居宅介護支援事業",
      },
      {
        id: 54,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5305",
        name: "指定訪問看護事業",
      },
      {
        id: 55,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5306",
        name: "有料老人ホーム",
      },
      {
        id: 56,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5307",
        name: "老人憩いの家",
      },
      {
        id: 57,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5308",
        name: "老人休養ホーム",
      },
      {
        id: 58,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5309",
        name: "在宅介護支援センター",
      },
      {
        id: 59,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5310",
        name: "訪問入浴介護事業",
      },
      {
        id: 60,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5311",
        name: "地域包括支援センター",
      },
      {
        id: 61,
        category: "老人福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5390",
        name: "その他老人施設・事業",
      },
      {
        id: 62,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0404",
        name: "視聴覚障害者情報提供施設（点字出版施設を除く）",
      },
      {
        id: 63,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0409",
        name: "身体障害者福祉センターの中の地域活動支援センターの事業に相当する事業",
      },
      {
        id: 64,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5401",
        name: "身体障害者福祉センター",
      },
      {
        id: 65,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5402",
        name: "補装具製作施設",
      },
      {
        id: 66,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5403",
        name: "盲導犬訓練施設",
      },
      {
        id: 67,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5404",
        name: "視聴覚障害者情報提供施設のうち点字出版施設",
      },
      {
        id: 68,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5405",
        name: "身体障害者相談支援事業",
      },
      {
        id: 69,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5406",
        name: "身体障害者生活訓練等事業",
      },
      {
        id: 70,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5407",
        name: "手話通訳事業",
      },
      {
        id: 71,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5408",
        name: "身体障害者小規模作業所",
      },
      {
        id: 72,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5409",
        name: "身体障害者デイサービス事業・単",
      },
      {
        id: 73,
        category: "身体障害者福祉に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5490",
        name: "その他身体障害者施設・事業",
      },
      {
        id: 74,
        category: "困難な問題を抱える女性への支援に関係する施設等",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0701",
        name: "女性自立支援施設　",
      },
      {
        id: 75,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3202",
        name: "居宅介護事業",
      },
      {
        id: 76,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3203",
        name: "行動援護事業",
      },
      {
        id: 77,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3204",
        name: "共同生活援助事業（グループホーム）",
      },
      {
        id: 78,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3205",
        name: "短期入所事業（ショートステイ）",
      },
      {
        id: 79,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3206",
        name: "重度訪問介護事業",
      },
      {
        id: 80,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3207",
        name: "重度障害者等包括支援事業",
      },
      {
        id: 81,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3208",
        name: "生活介護事業",
      },
      {
        id: 82,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3209",
        name: "療養介護事業",
      },
      {
        id: 83,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3210",
        name: "自立訓練事業",
      },
      {
        id: 84,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3211",
        name: "就労移行支援事業",
      },
      {
        id: 85,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3212",
        name: "就労継続支援事業",
      },
      {
        id: 86,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3213",
        name: "移動支援事業",
      },
      {
        id: 87,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3214",
        name: "同行援護事業",
      },
      {
        id: 88,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3216",
        name: "地域活動支援センター",
      },
      {
        id: 89,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3217",
        name: "福祉ホーム",
      },
      {
        id: 90,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3218",
        name: "障害者支援施設",
      },
      {
        id: 91,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3219",
        name: "就労定着支援事業",
      },
      {
        id: 92,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3220",
        name: "自立生活援助事業",
      },
      {
        id: 93,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "3",
        partitioncodename: "特定介護保険施設等",
        typecode: "3221",
        name: "就労選択支援事業",
      },
      {
        id: 94,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5501",
        name: "知的障害者相談支援事業",
      },
      {
        id: 95,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5502",
        name: "知的障害者小規模作業所",
      },
      {
        id: 96,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5503",
        name: "知的障害者デイサービス事業",
      },
      {
        id: 97,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5590",
        name: "その他知的障害者施設・事業",
      },
      {
        id: 98,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5601",
        name: "精神障害者居宅介護等事業",
      },
      {
        id: 99,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5602",
        name: "精神障害者短期入所事業",
      },
      {
        id: 100,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5603",
        name: "精神障害者小規模作業所",
      },
      {
        id: 101,
        category: "障害者総合支援法に関係する施設等",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5690",
        name: "その他精神障害者施設・事業",
      },
      {
        id: 102,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "1",
        partitioncodename: "社会福祉施設等",
        typecode: "0702",
        name: "社会事業授産施設",
      },
      {
        id: 103,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5105",
        name: "診療施設（病院・診療所）",
      },
      {
        id: 104,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5701",
        name: "母子福祉センター",
      },
      {
        id: 105,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5702",
        name: "母子休養ホーム",
      },
      {
        id: 106,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5703",
        name: "母子家庭居宅介護等事業",
      },
      {
        id: 107,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5704",
        name: "寡婦居宅介護等事業",
      },
      {
        id: 108,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5705",
        name: "父子家庭居宅介護等事業",
      },
      {
        id: 109,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5790",
        name: "その他母子施設・事業",
      },
      {
        id: 110,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5801",
        name: "隣保事業",
      },
      {
        id: 111,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5802",
        name: "福祉サービス利用援助事業",
      },
      {
        id: 112,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5803",
        name: "社会福祉事業関連連絡事業",
      },
      {
        id: 113,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5804",
        name: "社会福祉事業関連助成事業",
      },
      {
        id: 114,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5805",
        name: "へき地保健福祉館",
      },
      {
        id: 115,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5806",
        name: "地域福祉センター",
      },
      {
        id: 116,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5807",
        name: "その他障害者施設・事業",
      },
      {
        id: 117,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5808",
        name: "法人関連事業　　",
      },
      {
        id: 118,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5809",
        name: "日中一時援助",
      },
      {
        id: 119,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5810",
        name: "小規模作業所",
      },
      {
        id: 120,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5890",
        name: "その他施設・事業",
      },
      {
        id: 121,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5901",
        name: "収益事業（販売業）",
      },
      {
        id: 122,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5902",
        name: "収益事業（出版事業）",
      },
      {
        id: 123,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5903",
        name: "収益事業（不動産賃貸）",
      },
      {
        id: 124,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "5990",
        name: "その他の収益事業",
      },
      {
        id: 125,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "6001",
        name: "相談支援事業",
      },
      {
        id: 126,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "9991",
        name: "契約外の社会福祉施設",
      },
      {
        id: 127,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "9992",
        name: "老人保健施設",
      },
      {
        id: 128,
        category: "その他の社会福祉施設 その他の施設",
        partitioncode: "2",
        partitioncodename: "申出施設等",
        typecode: "9993",
        name: "その他",
      },
    ],
  } as {
    [key: string]: {
      id: number;
      category: string;
      partitioncode: string;
      partitioncodename: string;
      typecode: string;
      name: string;
    }[];
  },
} as const;

export const facilityHeadfields = {
  facilities: {
    facilityHeads1: [
      { id: 1, name: "社会福祉施設等" },
      { id: 2, name: "特定介護保険施設等" },
    ],
    facilityHeads2: [
      { id: 1, name: "社会福祉施設等" },
      { id: 2, name: "特定介護保険施設等" },
      { id: 3, name: "申出施設等" },
    ],
  } as {
    [key: string]: {
      id: number;
      name: string;
    }[];
  },
} as const;

export const facilityLoopListAll = {
  facilities: {
    facilityLoopList: [
      { id: 1, name: "生活保護及び自立支援に関係する施設" },
      { id: 2, name: "児童福祉に関係する施設等" },
      { id: 3, name: "老人福祉に関係する施設等" },
      { id: 4, name: "身体障害者福祉に関係する施設等" },
      { id: 5, name: "困難な問題を抱える女性への支援に関係する施設等" },
      { id: 6, name: "障害者総合支援法に関係する施設等" },
      { id: 7, name: "その他の社会福祉施設 その他の施設" },
    ],
  } as {
    [key: string]: {
      id: number;
      name: string;
    }[];
  },
} as const;

export default facilitiesfields;
